// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAl0M_PJAxepj7x6y4k5Xq73mCZM0E8oCs",
  authDomain: "yasasinhamileyim.com",//localhost için "yasasinhamileyim.firebaseapp.com",
  projectId: "yasasinhamileyim",
  storageBucket: "yasasinhamileyim.firebasestorage.app",
  messagingSenderId: "67420536866",
  appId: "1:67420536866:web:c71decc40dce926346ca7b",
  measurementId: "G-VP2GLTF90X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Google Auth Provider ayarları
googleProvider.setCustomParameters({
  prompt: 'select_account' // Her seferinde hesap seçimi göster
});

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);